hermes = function() {

	var DeleteWarning = Curriculog.WarningDialog.extend({
		title: 'Confirm Delete',
		message: 'Are you sure you want to delete?',
		buttons: {
			Delete: function () {
				this.deleteItem();
				this.close();
			},
			Cancel: 'close'
		},
		deleteItem: function () {
			// Not Implemented
		}
	});

	var objHermes = {};
	var objDialog = dialog();
	var objDom	= dom();
	var popups = [];

	/* initialize growls */
	$('#growls').notify();

	objHermes.loadWindow = function(pageURL){
		hImport = popWindow(pageURL, 'Import');
		popups.push(hImport);
		return popWindow(pageURL, 'Import');
	};

	objHermes.registerPopup = function(popup) {
		popups.push(popup);
	};

	objHermes.closePopups = function() {
		popups.map(function(popup){
			popup.close();
		});
		popups = [];
	};

/****************************************************************************************************/
/*************************                                                  *************************/
/**********                                                                                **********/
/*****                                   HERMES: SYSTEMS                                        *****/
/**********                                                                                **********/
/*************************                                                  *************************/
/****************************************************************************************************/

	/*
	 * getSystems: retrieves systems as html with dropdowns to manage status of systems
	 * used by procedures file on page load of settings
	 * takes: dom id to replace with the html
	 * returns: html code for settings page
	 *-Removed in unify-proposal-form. This is referenced once in settings.js but its commented out-/
	objHermes.getSystems = function(id, hermesSuccess) {
		if (hermesSuccess === undefined) {
			objHermes.checkHermes(function(hermesSuccess) {
				getSystems(id, hermesSuccess);
			});
		} else {
			getSystems(id, hermesSuccess);
		}

		function getSystems(id, hermesSuccess) {
			$.ajax({
				url: '/hermes/getSystems',
				data: {
					active: false,
					returnMeta: true,
					hermesSuccess: hermesSuccess,
					display: 'getSystems'
				},
				type: 'GET',
				beforeSend: function() {
					objDom.addLoadingMask(id);
				},
				success: function(data) {
					$(id).contents().remove();
					$(id).html(data);
					objDom.removeMask(id);
					objDom.verticalStretchList();
				}
			});
		}
	};*/


	/*
	 * validateSystemSettings: checks the validity of the hermes url and client
	 * used by procedures file on settings page, ap pages
	 * takes: nothing
	 * returns: 0/1
	 */

	objHermes.validateSystemSettings = function(useDialog, callback) {

		if (useDialog === undefined) {
			useDialog = false;
		}

		var dialog;

		$.ajax({
			url: '/hermes/validateHermes.json',
			type: 'GET',
			data: {
				apiUrl: $('#systemHermesUrl').val(),
				apiClient: $('#systemHermesClient').val()
			},
			success: function(data) {
				if (useDialog && data.success == "0") {
					dialog = objDialog.createBasicWarningDialog('system-settings-bad-dialog', function(dialog, defaults) {
						// Message
						$(dialog).append('The Integration Manager Settings you have entered are not valid. Please try again.');

						// Actions
						defaults.buttons = {
							Close: function() {
								// STUFF
								$(this).dialog('close');
							}
						};
						$(dialog).dialog(defaults);

					});

					callback && callback(data.success);

				} else if (useDialog && data.success == "1") {
					dialog = objDialog.createBasicDialog('system-settings-good-dialog', 'System Settings Validated', function(dialog, defaults) {
						// Message
						$(dialog).append('The Integration Manager Settings are valid.');

						// Actions
						defaults.buttons = {
							Close: function() {

								callback && callback(data.success);

								$(this).dialog('close');
							}
						};
						$(dialog).dialog(defaults);
					});

				} else {
					callback && callback(data.success);
				}
			}
		});
	};

/*
	 * checkSystemSettings: checks whether the hermes url and client have been validated
	 * pulls from settings, not from hermes
	 * used by procedures file on settings page, ap pages
	 * takes: nothing
	 * returns: 0/1
	 */

	objHermes.checkHermes = function(callback) {

		var dialog;

		$.ajax({
			url: '/hermes/isMapped.json',
			type: 'GET',
			success: function(result) {
				callback && callback(result.isMapped);
			}
		});
	};

	/*
	 * getSystemsSelect: retrieves systems as json and populates the hermes-map-system dropdown
	 * used by procedures file on page load of hermesMap (integration settings -> Map External Systems)
	 * takes: dom id of the select
	 * returns: select options
	 */

	objHermes.getSystemsSelect = function(id) {
		var systems = JSON.parse($('#hermes-maps-json').val());

		var html = '<option value="">Select System</option>';
		$.each(systems.maps, function(key, item) {
			var classes = [];

			if (item.meta !== null) {
				if (item.meta.mms == '1') {
					classes.push('mms');
				}
				if (item.meta.mlt == '1') {
					classes.push('mlt');
				}
				if (item.meta.dmh == '1') {
					classes.push('dmh');
				}
			}


			html += '<option value="' + item.id + '" class="' + classes.join(' ') + '">' + item.name + '</option>';
		});

		$(id).contents().remove();
		$(id).html(html);
		objDom.removeMask(id);
		objDom.verticalStretchList();

	};

	/*
	 * getSystemItems: gets an AP's template fields and puts the results into a hidden field
	 * used by procedures file when hermesSearch popup is loaded (after originator selects a legend he wants
        to import from
	 * takes: apId
	 * returns: nothing
	 */

	objHermes.getSystemItems = function(apId, itemType, callback) {

		$.ajax({
			url: '/hermes/getSystemItems.json',
			data: {
				hermesSystem: 'curriculog',
				id: apId,
				template: true,
				itemType: itemType
			},
			type: 'GET',
			beforeSend: function() {
				objDom.addLoadingMask('#hermes-map-details-content');
			},
			success: function(data) {
				$('#hermes-system-json').val(JSON.stringify(data.items));
				callback && callback();
			}
		});
	};


	objHermes.getSystemMeta = function(pluginName, itemType, options, mapId, externalMapId, callback) {

		// get the plugin for this map
		var hermesSystem = pluginName.charAt(0).toUpperCase() + pluginName.slice(1);

		if (pluginName !== '') {
			$.ajax({
				url: '/hermes/getSystemMeta.json',
				data: {
					pluginName: pluginName,
					hermesSystem: hermesSystem,
					itemType: itemType,
					options: options,
					mapId: mapId
				},
				type: 'GET',
				beforeSend: function() {
					objDom.addLoadingMask('#hermes-map-details-content');
				},
				success: function(data) {

					if(data.results !== false) {

						switch(itemType) {
							case 'hierarchy':
								// `results` needs to be passed as a string, for IE See #278
								// See issue #278
								var results = JSON.stringify(data.results);
								window.opener.entityObject.importEntities(hermesSystem, externalMapId, results);
								window.close();
								break;
							default:
								window.opener.console.log(data.results, itemType, options);
								window.opener.smartfield().importDataset(data.results, itemType, options);
								window.close();
						}

					}
				}
			});
		}
	};


	/*
	 * getSystemMetaOptions: retrieve the custom dataset types from the hermes plugin for the selected Map ID
	 * used by settings
	 * takes: nothing
	 * returns: nothing
	 */
	objHermes.getSystemMetaOptions = function(mapId, pluginName, itemType) {
		// get the plugin for this map
		pluginName = $('#plugin-name').val();

		if (pluginName !== '') {
			$.ajax({
				type: 'GET',
				url: '/hermes/getSystemMetaOptions.json',
				data: {
					pluginName: pluginName,
					hermesSystem: capitalize(pluginName),
					itemType: itemType,
					mapId: mapId
				},
				success: function(data) {
					$.each(data.results, function(index, item) {
						$.each(item, function(id, name) {
							$('#hermes-types-option').append(
								'<option value="' + id + '">' + name + '</option>'
							);
						});
					});
					callback && callback();
				}
			});
		}
	};


	/*
	 * saveSystemsSettings: saves system settings
	 * used by settings to save the external systems and their settings (NOT THE URL OR CLIENT)
	 * takes: nothing
	 * returns: nothing
	 */

	objHermes.saveSystemsSettings = function(settingId, callback) {
		function save(params) {
			if (params.length > 0) {
				$.ajax({
					url: '/hermes/saveSystemsSettings.json',
					data: {systems : params},
					type: 'PUT',
					beforeSend: function() {
						objDom.addMask('#summary-' + settingId + ' .summary-content:eq(0)');
					},
					success: function(data) {
						objDom.removeMask('#summary-' + settingId + ' .summary-content:eq(0)');
						callback && callback(settingId);
					}
				});
			} else {
				callback && callback(settingId);
			}
		}

		var changed = [];
		var params = [];

		$('#settings-external-systems select').each(function(index, item) {
			system = {
				shortName : item.name.replace('[status]', ''),
				status : $(item).val()
			};

			currentSettings = JSON.parse($($('input[name="' + system.shortName + '[currentSettings]"]')).val());
			system.name = $('label[for="' + system.shortName + '[status]"]').text();

			var meta = {};
			if ($('input[name="' + system.shortName + '[mms]"]').length > 0) {
				meta['mms'] = ($('input[name="' + system.shortName + '[mms]"]').is(':checked')) ? 1 : 0;

				// check if changed
				if (Number(currentSettings.mms) != Number(meta['mms']) ) {
					changed.push(system.name);
				}
			}

			if ($('input[name="' + system.shortName + '[mlt]"]').length > 0) {
				meta['mlt'] = ($('input[name="' + system.shortName + '[mlt]"]').is(':checked')) ? 1 : 0;

				// check if changed
				if ( (Number(currentSettings.mlt) != Number(meta['mlt'])) && ($.inArray(system.name, changed) == -1) ) {
					changed.push(system.name);
				}
			}

			if ($('input[name="' + system.shortName + '[dmh]"]').length > 0) {
				meta['dmh'] = ($('input[name="' + system.shortName + '[dmh]"]').is(':checked')) ? 1 : 0;
			}

			if (! $.isEmptyObject(meta)) {
				system['meta'] = meta;
			}

			params.push(system);
		});

		// Remove this line to add the check for destructive changes back into this function
		// changed = [];

		// check to see if any changes made were destructive kind (mms/mlt changed),
		// which will cause all maps, legends and data to be deleted in hermes
		// if so, warning dialog
		if (changed.length > 0) {
			var dialog = objDialog.createDOMWarningDialog('systems-setting-warning', function(dialog, defaults) {

				$('#systems-affected').contents().remove();

				$.each(changed, function(index, item) {

					if ((changed.length > 1) && (index == changed.length - 1)) {
						$('#systems-affected').append(' and ');
					}

					$('#systems-affected').append('<strong>' + item + '</strong>');

					if ((changed.length > 2) && (index < changed.length - 2)) {
						$('#systems-affected').append(', ');
					}

				});

				// Actions
				defaults.buttons = {
					'Continue': function() {
						save(params);
						$(this).dialog('close');
					},
					Cancel: function() {
						var objSettings = settings();
						objSettings.getFlyout(11);
						$(this).dialog('close');
					}
				};
				$(dialog).dialog(defaults);

			});

		} else {
			save(params);
		}
	};




/****************************************************************************************************/
/*************************                                                  *************************/
/**********                                                                                **********/
/*****                                     HERMES: MAPS                                         *****/
/**********                                                                                **********/
/*************************                                                  *************************/
/****************************************************************************************************/

	/*
	 * getScopedMapsBySystemJSON: retrieves all maps for all systems, regardless of system status
	 * used by procedures file on page load of hermesTasks (integration settings -> Sync External Systems)
           for use with the map select (getSystemsSelect)
	 * takes: display
	 * returns: nothing
	 */
	objHermes.getScopedMapsBySystemJSON = function(maskLayer, callback) {
		$.ajax({
			url: '/hermes/getScopedMaps.json',
			data: {active: false, groupBySystem: true},
			type: 'GET',
			beforeSend: function() {
				objDom.addLoadingMask(maskLayer);
			},
			success: function(mapData) {
				delete mapData['appMeta'];
				$('#hermes-maps-json').val(JSON.stringify(mapData));

				callback && callback();

				objDom.removeMask(maskLayer);

			}
		});

	};

	/*
	 * getScopedMaps: retrieves all maps for all systems, regardless of system status
	 * used by procedures file on page load of hermesMap (integration settings -> Map External Systems)
           and hermesTask (integration settings -> Sync External Systems) for the map select
	 * takes: display
	 * returns: nothing
	 */
	objHermes.getScopedMapsBySystem = function(display, callback) {
		$.ajax({
			url: '/hermes/getMapElements',
			data: {
				display: display
			},
			type: 'GET',
			beforeSend: function() {
				objDom.addLoadingMask('#existing-hermes-maps-list');
			},
			success: function(results) {
				$('#existing-hermes-maps').contents().remove();
				$('#existing-hermes-maps').html(results);

				if (callback !== undefined) {
					callback();
				} else {
					objDom.removeMask('#existing-hermes-maps-list');
				}
			}
		});
	};


	/*
	 * getScopedMapsSelect: retrieves all maps as json and populates the hermes-task-name dropdown
	 * used by procedures file on page load of hermesTasks (integration settings -> Map External Systems)
	 *
	 * Note: older tasks where legend was not available for selection have legend as None. This appears in the
	 * dropdown as "No Legend" option. Otherwise, we load an empty string, which is equivalent to "Select X" option.
	 * takes:
	 * 		systemId 	(optional, default: undefined) (if map id is provided, we extract systemId from the
	 *					JSON in the hidden field)
	 * 		mapId 		(optional, default: undefined)
	 * 		legendId 	(optional, default: undefined)
	 * 		taskId 		(optional, default: undefined)
	 *
	 * returns: select options
	 */
	objHermes.getScopedMapsBySystemSelect = function(systemId, mapId, legendId, taskId, callback) {
		var systems = JSON.parse($('#hermes-maps-json').val());
		var legend_dataset = [];

		var systemSelect = $('#hermes-task-system');
		var mapSelect = $('#hermes-task-map');
		var legendSelect = $('#hermes-task-legend');

		// empty current contents
		systemSelect.contents().remove();
		mapSelect.contents().remove();
		legendSelect.contents().remove();

		// if we are not editing an item, append empty options
		if (! taskId) {
			systemSelect.append('<option value="" selected="selected">Select System</option>');
			mapSelect.append('<option value="" selected="selected">Select Map</option>');
			legendSelect.append('<option value="" selected="selected">Select Legend</option>');
		}

		// get the systemId if mapId given (from edit task)
		if (systems !== null) {
			$.each(systems, function(key, item) {
				$.each(item.maps, function(key2, map) {
					if (map.id == mapId) {
						systemId = item.id;
						return true;
					}
				});
			});
		}

		// populate selects
		var legend_dataset = [];
		if (systems !== null) {
			$.each(systems, function(key, system) {
				$.each(system.maps, function(key2, map) {
					// populate the maps dropdown
					if (map.system_id === +systemId) {
						var mapOption = $('<option />', {value: map.id, text: map.name});
						mapSelect.append(mapOption);
					}
					if ((map.id === +mapId) && (map.legends.length > 0)) {
						legend_dataset = map.legends.slice();
					}
				});

				// populate the systems dropdown, and if a system has no maps, disables that system option
				if (system.maps.length === 0) {
					var systemOption = $('<option />', {value: system.id, disabled: true, text: system.name + ' [no maps]'});
				} else {
					var systemOption = $('<option />', {value: system.id, text: system.name});
				}
				systemSelect.append(systemOption);
			});
		}

		// populate the legends dropdown
		var legend_option = $('<option />', {value: '', text: 'No Legend'});
		legendSelect.append(legend_option);

		$.each(legend_dataset, function(key3, legend) {
			if (legend.parent === null) {
				var legendName = legend.label ? legend.system_template_name + ' > ' + legend.label : legend.system_template_name,
				    legendOption = $('<option />', {value: legend.id, text: legendName});

				legendSelect.append(legendOption);
			}
		});

		/*
		UI/UX Business Rules
		If creating a task:
			1. No system selected, system enabled, map and legend disabled
			2. System selected, system and map enabled, legend disabled
			3. System and Map selected, system, map and legend enabled

		If editing a task:
			1. All dropdowns disabled and showing selection
			2. Legend is not required (if no legend, "No Legend" option is selected and saved as null)
		*/

		// editing
		if (taskId) {
			systemSelect.prop('disabled', true);
			mapSelect.prop('disabled', true);
			legendSelect.prop('disabled', true);

			systemSelect.find('option[value="' + systemId + '"]').prop('selected', true);
			mapSelect.find('option[value="' + mapId + '"]').prop('selected', true);
			if (legendId) {
				legendSelect.find('option[value="' + legendId + '"]').prop('selected', true);
			} else {
				legendSelect.find('option[value=""]').prop('selected', true);
			}

		// creating
		} else {
			systemSelect.prop('disabled', false);
			mapSelect.prop('disabled', true);
			legendSelect.prop('disabled', true);

			// systemId, mapId and legendId default to undefined
			if (systemId) {
				mapSelect.prop('disabled', false);
				systemSelect.find('option[value="' + systemId + '"]').prop('selected', true);
			}

			if (mapId) {
				legendSelect.prop('disabled', false);
				mapSelect.find('option[value="' + mapId + '"]').prop('selected', true);
			}

			if (legendId) {
				legendSelect.find('option[value="' + legendId + '"]').prop('selected', true);
			}
		}

		callback && callback();

	};


	/*
	 * getScopedMap: retrieves the columns of a single map
	 * used by editScopedMap
	 * takes: id of the map
	 * returns: nothing
	 */

	objHermes.getScopedMap = function(id, callback) {
		// This retrieves the columns of a map
		var status = $('input[name="system-'+ $('#hermes-map-system').val() +'-status"]').val();
		var isLocked = (status=='locked') ? 1 : 0;

		$.ajax({
			url: '/hermes/getScopedMap',
			data: {
				id: id,
				isLocked: isLocked,
				display: 'getScopedMap'
			},
			type: 'GET',
			beforeSend: function() {
				objDom.addLoadingMask('#hermes-map-details');

				// destroy old sortable
				$('#hermes-map-columns tbody tr').sortable('destroy');

			},
			success: function(data) {
				$('#hermes-map-details').contents().remove();
				$('#hermes-map-details').html(data);

				var target = $('#hermes-map-details');
				if( target.length ) {
					$('html, body').animate({
						scrollTop: target.offset().top
					}, 1500);
				}

				// $('body').scrollTo($('#hermes-map-details'),{duration:1500});

				// enable sortable
				$('#hermes-map-columns tbody').sortable({
					items: 'tr',
					handle: '.section-row-draggable-handle',
					update: function(event, ui) {
						objHermes.updateMapDisplay();
					}
				});

				// enable chosen plugin
				$('#unique-item-identifier').chosen().change(function() {
					$('#unique-item-identifier').trigger("liszt:updated");
				}).trigger("liszt:updated");


				// placing a callback for security reasons
				callback && callback();

				if (mapId && dmh === 0){
					objDom.removeMask('#existing-hermes-maps-list');
				}

				objDom.removeMask('#hermes-map-details');
			}
		});

	};

	/*
	 * getImportStatus: Checks if there are maps and allows import for admin meta info (such as hierarchy)
        inserts the import button into the dom
	 * used by: hierarchy procedures on load of page
	 * takes: nothing
	 * returns: nothing
	 */

	objHermes.getImportStatus = function(callback) {
		$.ajax({
			url: '/hermes/getScopedMaps.json',
			data: {
				active: true
			},
			type: 'GET',
			success: function(data) {
				if (! $.isEmptyObject(data.maps)) {
					callback && callback(true);

				} else {
					callback && callback(false);
				}


			}
		});
	};



	/*
	 * editMap: loads map's important details and columns into details area for editing
	 * used by "edit item" button and create new map button click event on hermesMap
	 * takes: mapId, callback
	 * returns: nothing
	 */

	objHermes.editMap = function(mapId, runDmh, callback) {
		// This retrieves the columns of a map
		var status = $('input[name="system-'+ $('#hermes-map-system').val() +'-status"]').val();

		var hermesSystem = '';
		if (($('#hermes-map-system').val() !== '') && ($('#hermes-map-system option:selected').length > 0)) {
			hermesSystem = $('#hermes-map-system option:selected').attr('class').match(/short-(\w*)/)[1];
		}

		var data = {
			id: mapId,
			systemId: ($('#hermes-map-system').val() !== '') ? $('#hermes-map-system').val() : '',
			hermesSystem : hermesSystem,
			runDmh: runDmh,
			mapName: ($('#hermes-map-name').is('select')) ?
				$('#hermes-map-name option:selected').text().trim().replace(' [exists]','') : $('#hermes-map-name').val(),
			externalMapId: (($('#hermes-map-name').is('select')) && ($('#hermes-map-name option:selected').val() !== '')) ?
				$('#hermes-map-name option:selected').val() : 0,
			status: ($('#hermes-map-status').is(':checked')) ? 'active' : 'inactive',
			display: 'getMap'
		};

		if (runDmh === 1){
			objHermes.getMapTask(data, callback);
		}

		else {
			objHermes.displayMap(data, 'GET', callback);
		}
	};


	objHermes.displayMap = function(data, type, callback) {
		
		$.ajax({
			url: '/hermes/getMap',
			data: data,
			type: type,
			beforeSend: function() {
				objDom.addLoadingMask('#hermes-map-details');

				// destroy old sortable
				var isSortable = ($('#hermes-map-columns tbody tr:data(sortable)')).length ? true : false;
				if (isSortable) {
					$('#hermes-map-columns tbody tr').sortable('destroy');
				}


			},
			success: function(data) {
				$('#hermes-map-details').contents().remove();
				$('#hermes-map-details').html(data);

				var target = $('#hermes-map-details');
				if( target.length ) {
					$('html, body').animate({
						scrollTop: target.offset().top
					}, 1500);
				}

				// enable sortable
				$('#hermes-map-columns tbody').sortable({
					items: 'tr',
					handle: '.section-row-draggable-handle',
					update: function(event, ui) {
						objHermes.updateMapDisplay();
					}
				});

				$('#unique-item-identifier').chosen().change(function() {
					$('#unique-item-identifier').trigger("liszt:updated");
				}).trigger("liszt:updated");

				// placing a callback for security reasons
				callback && callback();

				objDom.removeMask('#hermes-map-details');
			}
		});
	};


	objHermes.getMapTask = function(data, callback) {
		
		$.ajax({
			type: 'POST',
			url: '/gearman-job.json',
			contentType: 'application/json',
			data: JSON.stringify({
				functionName: 'get_hermes_map_task',
				workload: {
					module_name: 'hermesMap',
					method_name: 'getMap',
					method_args: {
						id: data.id,
						hermesSystem : data.hermesSystem,
						mapName: data.mapName,
						externalMapId: data.externalMapId,
						runDmh: data.runDmh,
						use_mc_cache: (data.id != 0) ? false : true
					}
				}
			}),
			beforeSend: function() {
				objDom.addLoadingMask('#hermes-map-details');
				var isSortable = ($('#hermes-map-columns tbody tr:data(sortable)')).length ? true : false;
				if (isSortable) {
					$('#hermes-map-columns tbody tr').sortable('destroy');
				}

			},

			success: function (results) {
				objHermes.pollForImportStatus(results.jobHandle, '#hermes-map-details', data, callback);
			},
		});
	};



	objHermes.pollForImportStatus = function (taskId, selector, data, callback) {
		var updateCallback = function (results) {
			var status = results.status;
			var datetime = getCurrentDate();

			// task is queued
			if (status.state === 'QUEUED') {
				msg = 'Map Creation is waiting to begin. (last checked ' + datetime + ')';
				objDom.addCustomMask(selector, msg, 50);

			// task is running
			} else if(status.state === 'RUNNING') {
				msg = 'Map Creation is in process. (last checked ' + datetime + ')';
				objDom.addCustomMask(selector, msg, 50);

			// task is finished
			} else if (status.state === 'FINISHED') {
				objDom.removeMask(selector);
				data.results = results.status.meta.model;
				objHermes.displayMap(data, 'POST', callback);

			} else if (status.state === 'ERROR') {
				objDom.removeMask(selector);
				$('#growls').notify("create","warning-template", {
					title: 'Warning',
					text: 'An error occurred while attempting to create a map. Please try again or contact a system administrator.'
				});
			}
		};

		pollJobStatus(taskId, updateCallback);
	};


	/*
	 * saveMap: saves map
	 * used by "save map" button click event on hermesMap
	 * takes: nothing
	 * returns: nothing
	 */

	objHermes.saveMap = function() {
		function save(map) {
			$.ajax({
				url: '/hermes/saveMap.json',
				data: map,
				type: 'POST',
				beforeSend: function() {
					objDom.addLoadingMask('#hermes-map-details-content');
				},
				success: function(data) {
					window.location.href = '/hermes?display=hermesMap';
					objDom.removeMask('#hermes-map-details-content');
				}
			});
		}

		var systemDefinitions = [];
		$('#hermes-map-columns tbody tr').each(function(index, item) {
			systemDefinitions.push($(item).find('select').val());
		});

		// get meta
		var details = ($('#hermes-map-meta').val() !== '') ? JSON.parse($('#hermes-map-meta').val()) : {};
		var selectedMap = ($('#hermes-map-name').is('select')) ? $('#hermes-map-name option:selected').val() : 0;

		if (selectedMap && $.isNumeric(selectedMap)) {
			details['external-map-id'] = +(selectedMap);
		} else {
			details['external-map-id'] = selectedMap;
		}

		// mark which fields are the unique identifiers
		// for example, for a course map it could be item Oid, or prefix, code, and name
		details['uniqueFields'] = $('#unique-item-identifier').val();

		// make sure the identifiers are all included in the map
		var invalidIdentifier = false;
		if (details['uniqueFields'] !== null) {
			$.each(details['uniqueFields'], function(index, item) {
				if($.inArray(item, systemDefinitions) == -1) {
					invalidIdentifier = true;
				}
			});
		}


		var map = {
			system : $('#hermes-map-system').val(),
			name : ($('#hermes-map-name').is('select')) ?
				$('#hermes-map-name option:selected').text().trim().replace(' [exists]','') :
				$('#hermes-map-name').val(),
			id : $('#hermes-map-id').val(),
			systemFieldNames : $('#sourceFieldNames').val(),
			systemDefinitions : systemDefinitions,
			action : 'modify',
			status : ($('#hermes-map-status').is(':checked')) ? 'active' : 'inactive',
			details : JSON.stringify(details)
		};

		if( (Number($('#legends').val()) === 0) &&
			(map.status === 'active') &&
			(details.uniqueFields !== null) &&
			(! invalidIdentifier) ) {

			save(map);

		} else if (details.uniqueFields === null) {
			$('#empty-identifiers').dialog({
				resizable: false,
				height:140,
				modal: true,
				buttons: {
					'Ok': function() {
						$(this).dialog('close');
					}
				}
			});

		} else if (invalidIdentifier) {
			$('#missing-identifier').dialog({
				resizable: false,
				height:140,
				modal: true,
				buttons: {
					'Ok': function() {
						$(this).dialog('close');
					}
				}
			});

		} else if (map.status !== 'active') {
			$('#inactive-map-warning').dialog({
				resizable: false,
				height:210,
				modal: true,
				buttons: {
					'Save Map': function() {
						save(map);
						$(this).dialog('close');
					},
					'Cancel': function() {
						$(this).dialog('close');
					}
				}
			});


		} else {
			$('#save-warning').dialog({
				resizable: false,
				height:140,
				modal: true,
				buttons: {
					'Save My Changes': function() {
						save(map);
						$(this).dialog('close');
					},
					Cancel: function() {
						$(this).dialog('close');
					}
				}
			});
		}

	};

	/*
	 * deleteMap: deletes map and its parts
	 * used by "Delete map" click event on hermesMap
	 */
	objHermes.deleteMap = function(mapId, systemItemId, callback) {
		function _deleteMap () {
			return $.ajax({
				url: '/hermes/deleteMap.json',
				data: {id: mapId, systemItemId: systemItemId},
				type: 'PUT',
				beforeSend: function() {
					objDom.addLoadingMask('#existing-hermes-maps-list');
					// remove the current map if they are editing one
					$('#hermes-map-details').contents().remove();
				},
				success: function(data) {
					objDom.removeMask('#existing-hermes-maps-list');
					objHermes.getScopedMapsBySystem('getScopedMaps');
					callback && callback();
				}
			});
		}

		var mapName = $('[name="item-' + mapId + '-name"]').val();
		new DeleteWarning({
			message: 'Are you sure you want to delete the map <i> ' + mapName + '</i>?',
			deleteItem: _deleteMap
		});
	};


	objHermes.disableMap = function(id){
			if (id.indexOf("item-") !=-1) {
				system_id = id.substring("item-".length);
				var name = $('input[name="item-' + system_id + '-system-short"]').val();
				if(name == 'curriculog'){
					var apID = $('input[name="item-' + system_id + '-external-map-id"]').val();
					objHermes.isProgram(apID, system_id);
				}
			}
	};

	objHermes.isProgram = function(apID, system_id, callback) {
		$.ajax({
			url: '/hermes/isProgram.json',
			data: {
				apID: apID
			},
			type: 'GET',
			success: function(data) {
				if (data.results['type'] == 'program'){
					$('#existing-hermes-maps li#item-' + system_id).css({"backgroundColor": "#cccccc", "cursor": "default", "color": "#888888"});
					$('#existing-hermes-maps li#item-' + system_id).addClass('program');
				}
				callback && callback();
			}
		});
	};



/****************************************************************************************************/
/*************************                                                  *************************/
/**********                                                                                **********/
/*****                                   HERMES: LEGENDS                                        *****/
/**********                                                                                **********/
/*************************                                                  *************************/
/****************************************************************************************************/

	/*
	 * getLegends: Returns all legends mapped to a single AP in the bubble format
	 * used by: Approval Process Form (loads after clicking the 'maps' icon)
	 * takes: id (systemItemId - the curriculog AP id), editMode (true/false)
	 * returns: nothing
	 */

	objHermes.getLegends = function(id, callback) {
		editmode = ($('#process-status').val() == 'active') ? false : true;

		// id is the ap ID OR editmodeParent (if in edit mode)
		$.ajax({
			url: '/hermes/getScopedLegends',
			data: {
				systemItemId: id,
				dataType: $('input[name="type"]').val(),
				includeMaps: 'false',
				display: 'getAPLegends',
				editmode: editmode,
				returnActive: 0
			},
			type: 'GET',
			beforeSend: function() {
				objDom.addLoadingMask('#hermes-legends');
			},
			success: function(data) {
				$('#hermes-legends').contents().remove();
				$('#hermes-legends').html(data);

				// change the button name
				if ($('#hermes-legends li:not(.no-items)').length > 0) {
					$('#create-legend span').text('Manage Legends');
				} else {
					$('#create-legend span').text('Add Legends');
				}

				// mark legends as outdated, if applicable
				if($('#hermes-legends .outdated').length > 0) {
					$('#legends-outdated-message').addClass('active');
				} else {
					$('#legends-outdated-message').removeClass('active');
				}

				//Show warning in a form if we are updating an AP with associated legends
				if ($('#hermes-legends li:not(.no-items)').length > 0 && $('#hermes-legends .outdated').length === 0) {
					$('#contain-legends-message').addClass('active');
				}
				else{
					$('#contain-legends-message').removeClass('active');

				}

				approvalProcess().verticalStretch();

				callback && callback();

				objDom.removeMask('#hermes-legends');

			}
		});
	};

	/*
	 * getScopedLegends: Returns the maps and legends for the curriculog system in a list format
        if includeMaps is true, all maps, even those without legends, will be included
        if includeMaps is false, only the maps with legends will be included
	 * used by: procedures file on load of hermesLegend page
	 * takes: id (systemItemId - the curriculog AP id), includeMaps
	 * returns: nothing
	 */

	objHermes.getScopedLegends = function(id, type, includeMaps, userLevel, display, clearCache, getMapInfo, callback) {
		// id is the ap ID OR editmodeParent (if in edit mode)
		// new variable: getMapInfo: provides additional details about the map, such as external map Id and system short name
		var returnActive = 0;
		if (id === '') {
			returnActive = 1;
		}
		if (clearCache === true) {
			clearCache = true;
		} else {
			clearCache = false;
		}

		if (getMapInfo === true) {
			getMapInfo = true;
		} else {
			getMapInfo = false;
		}

		$.ajax({
			url: '/hermes/getScopedLegends',
			data: {
				systemItemId: id,
				includeMaps: includeMaps,
				dataType: type,
				display: display,
				userLevel: userLevel,
				returnActive: returnActive,
				clearCache: clearCache,
				getMapInfo: getMapInfo
			},
			type: 'GET',
			beforeSend: function() {
				objDom.addLoadingMask("#existing-hermes-legends");
			},
			success: function(data) {

				$("#existing-hermes-legends").contents().remove();
				$("#existing-hermes-legends").html(data);

				callback && callback();

				objDom.removeMask("#existing-hermes-legends");

			}
		});
	};


	/*
	 * getScopedLegendsJSON: retrieves all legends (even ones that are not current)
	 * Used on the tasks popup to specify a legend for a specific task/map.
	 * takes: nothing
	 * returns: all legends
	 */

	objHermes.getScopedLegendsByMapJson = function(callback) {
		$.ajax({
			url: '/rpc/hermeslegend/getAllLegends',
			type: 'GET',
			success: function(legendData) {
				delete legendData['appMeta'];
				var systems = JSON.parse($('#hermes-maps-json').val());
				$.each(systems.maps, function(key, system) {
					$.each(system.maps, function(key2, map) {
						// Make sure we have a map to check for legends
						if (map.id) {
							// Much faster as a loop is not involved: https://jsperf.com/hasownproperty-vs-in-vs-undefined/12
							if (typeof map['legends'] === 'undefined') {
								map.legends = [];
							}

							// Make sure we actually have legends created before attempting more processing
							if (!_.isEmpty(legendData)) {
								// If there is more than one legend created, loop through them and find the ones
								// that have the current map id and add those legends to the map
								if (_.isArray(legendData)) {
									var map_legends = _.where(legendData, {"map_id": map.id});

									// If we find legend(s) for this map, include it in the legends key
									if (map_legends.length) {
										_.map(map_legends, function(legend) {
											map.legends.push(legend);
										});
									}
								} else {
									// If we only have one legend, check the map id and add it to the map if the map id matches
									if (legendData.map_id === map.id) {
										map.legends.push(legendData);
									}
								}
							}
						}
					});
				});

				$('#hermes-maps-json').val(JSON.stringify(systems));
				callback && callback();
			}
		});
	};


	/*
	 * getProposalLegend: Checks for a valid legend for the proposal, and if found,
         inserts the import button into the proposal
	 * used by: proposal procedures on load of unlaunched proposal
	 * takes: apId
	 * returns: nothing
	 */

	objHermes.getProposalLegends = function(apId, type) {
		$.ajax({
			url: '/hermes/getScopedLegends.json',
			data: {
				systemItemId: apId,
				includeMaps: false,
				dataType: type,
				returnActive: 0
			},
			type: 'GET',
			success: function(data) {
				if (! $.isEmptyObject(data.legends)) {
					$('<button class="curriculog-proposal-action" id="curriculog-import-widget" title="Import"><img src="/images/icons/flat/import.png" /></button>').insertBefore($('.originator-tools #curriculog-launch-widget'));
					$('#isMapped').val('1');
				}

			}
		});
	};

	/*
	 * getLegend: Returns the details of a legend
	 * used by: HermesSearch popup to populate a hidden field
	 * takes: id
	 * returns: nothing
	 */

	objHermes.getLegend = function(id, callback) {
		$.ajax({
			url: '/hermes/getScopedLegend.json',
			data: {id: id},
			type: 'GET',
			beforeSend: function() {
				objDom.addLoadingMask('#hermes-legend-details-content');
			},
			success: function(data) {
				callback && callback(data);
				objDom.removeMask('#hermes-legend-details-content');
			}
		});
	};

	/*
	 * editLegend: creates the table using three hermes api calls: one for the AP (left), one for the
         map selected (right) and one for the legend (applied to the selects)
	 * used by edit-item link from procedure for hermesLegend popup
	 * takes: apId, mapId, legendId
	 * returns: nothing
	 */

	objHermes.editLegend = function(fromSystemItemId, toSystemItemId, mapId, legendId, type, mode) {
		$('#hermes-legend-details').addClass('active');

		// if there is a legend id, change title
		if (legendId > 0 && mode == 'edit') {
			$('#hermes-legend-details h2').text('Modify the Legend');
		} else if (mode == 'edit') {
			$('#hermes-legend-details h2').text('Create the Legend');
		} else {
			$('#hermes-legend-details h2').text('View the Legend');
		}

		$.ajax({
			url: '/hermes/getLegend',
			data: {
				fromSystemItemId: fromSystemItemId,
                toSystemItemId: toSystemItemId,
				mapId: mapId,
				legendId: legendId,
				type: type,
                display: 'getAPFields',
                mode: mode
			},
			type: 'GET',
			beforeSend: function() {
				$('#hermes-legend-details').slideDown('fast', function(){
					objDom.addLoadingMask('#hermes-legend-details');
				});
			},
			success: function(data) {

				$('#hermes-legend-columns-content').contents().remove();
				$('#hermes-legend-columns-content').html(data);

				if (mode == 'view') {
					$('#hermes-legend-details .fieldset-buttons').contents().remove();
				}

				var target = $('#hermes-legend-details');
				if( target.length ) {
					$('html, body').animate({
						scrollTop: target.offset().top
					}, 700);
				}

				// $('body').scrollTo($('#hermes-legend-details'),{duration:700});
				objDom.removeMask('#hermes-legend-details');

			}
		});

	};

	/*
	 * previewLegend: When user is importing an item into a proposal, this is screen 3.
        Creates the table using three hermes api calls: one for the AP (left), one for the
        curriculum item selected (right) and one for the legend (to organize the curriculum item data correctly)
	 * used by hermesAvailableLegends popup onLoad
	 * takes: apId, legendId, itemId
	 * returns: nothing
	 */

	objHermes.previewLegend = function(apId, legendId, itemId, proposalId, itemType, callback) {
		$('#hermes-legend-details').addClass('active');

		// if there is a legend id, change title
		if (legendId > 0) {
			$('#hermes-legend-details h2').text('Modify the Legend');
		} else {
			$('#hermes-legend-details h2').text('Create the Legend');
		}

		$.ajax({
			url: '/hermes/getLegendPreview',
			data: {
				hermesSystem: 'curriculog',
				systemItemId: apId,
				legendId: legendId,
				itemId: itemId,
				proposalId: proposalId,
				itemType: itemType,
				display: 'getLegendPreview'
			},
			type: 'GET',
			beforeSend: function() {
				objDom.addLoadingMask('#hermes-preview-legend');
			},
			success: function(data) {
				if (data.length > 1) {
					$('#hermes-legend-detail').contents().remove();
					$('#hermes-legend-detail').html(data);
					objDom.removeMask('#hermes-preview-legend');
				} else {
					$('#hermes-legend-detail').contents().remove();
					$('#hermes-legend-detail').html('<p class="error">This proposal uses an outdated version of its Approval Process, and the legend cannot be applied. Please create a new proposal from this Approval Process and try to import again.</p>');
					$('button[name="import-item"]').attr('disabled', true);
					objDom.removeMask('#hermes-preview-legend');
				}
			}
		});

	};



	/*
	 * saveLegend: saves legend
	 * used by "save legend" button click event on hermesLegend.
	 * if editmode, the legend will be saved in editModeCache until editmode is applied to ap
	 * takes: nothing
	 * returns: nothing
	 */

	objHermes.saveLegend = function() {

		var legendFields = {};
		var subLegends = [];
		var type = $('#type').length > 0 ? $('#type').val() : "course";

		if ($('.subLegend').length > 0) {

			$('.subLegend').each(function(index, item) {
				subLegend = {
					subLegendId: ($(item).find('input[name="id"]').val() !== '0') ? $(item).find('input[name="id"]').val() : '',
					subLegendType: $(item).find('input[name="type"]').val(),
					subLegendFields: {}
				};

				$('select[name^="subtemplate-field-' + subLegend.subLegendType + '"]').each(function(fieldIndex, field) {
					var key = $(this).attr('name').match(/subtemplate-field-\w*\[(\d*)\]/)[1];
					subLegend.subLegendFields[key] = $(field).val();
				});

				subLegends.push(subLegend);
			});

		}

		$('select[name^="template-field"]').each(function(index, item) {
			var key = $(this).attr('name').match(/template-field-\w*\[(\d*)\]/)[1];
			legendFields[key] = $(item).val();
		});

		var map = {
			id: ($('#hermes-legend-id').val() !== '0') ? $('#hermes-legend-id').val() : '',
			mapId: $('#hermes-map-id').val(),
			systemItemId: $('#approval-process-id').val(),
			legendFields: JSON.stringify(legendFields),
			subLegends: JSON.stringify(subLegends),
			label: $('#hermes-legend-label').val(),
			systemItemStatus: $('#approval-process-status').val(),
			type: type
		};

		// validate title fields are in the legend
		$.validity.start();
		$('#hermes-map-system').greaterThan( 0, 'This field is required.' );
		$('#hermes-map-name').greaterThan( 0, 'This field is required.' );
		$('tr.title select').each(function(index, item) {
			$(item).require();
		});
		var result = $.validity.end();



		if (result.valid) {
			$.ajax({
				url: '/hermes/saveLegend.json',
				data: map,
				type: 'POST',
				beforeSend: function() {
					objDom.addLoadingMask('#hermes-legend-details');
				},
				success: function(data) {
					// reload the legends tab
					var apId = $('#approval-process-id').val();
					var editmode = (window.opener.$('#process-status').val() == 'active') ? 0 : 1;
					window.opener.hermesObject.getLegends(apId);

					// if we are Managing Legends, reload list
					if ($('#existing-hermes-legends').length > 0) {
						$('#hermes-legend-details').slideUp('slow', function() {
							$(this).removeAttr('style');
							$(this).removeClass('active');
						});
						objHermes.getScopedLegends($('#approval-process-id').val(), $('#type').val(), false, 'admin', 'getScopedLegends');
						objDom.removeMask('#hermes-legend-details');

					// if we are editing a single legend, close the dialog
					} else {
						window.close();
					}

				}
			});

		}

	};

	/*
	 * deleteLegend: deletes legend
	 * used by approvalProcess.js Exit Edit Mode and Save Edit Mode
	 * takes: legendId
	 * returns: nothing
	 */

	objHermes.deleteLegend = function(legendId, mapId) {
		// if the legend is open, close it
		if ($('#hermes-legend-id').val() == legendId) {
			$('#hermes-legend-details').removeClass('active');
			$('#hermes-legend-details').slideUp('fast');
		}

		function _deleteLegend () {
			return $.ajax({
				url: '/hermes/deleteLegend.json',
				data: {
					id: legendId,
					systemItemId: $('#approval-process-id').val(),
					mapId : mapId,
					action: 'delete'
				},
				type: 'PUT',
				success: function(data) {
					var apId = $('#approval-process-id').val();
					var editmode = (window.opener.$('#process-status').val() == 'active') ? 0 : 1;
					window.opener.hermesObject.getLegends(apId);

					objHermes.getScopedLegends(
						$('#approval-process-id').val(),
						$('#type').val(),
						false,
						'admin',
						'getScopedLegends'
						);
				}
			});
		}
		var legendName = $('#item-' + legendId + '-name').val();
		new DeleteWarning({
			message: 'Are you sure you want to delete the legend <i>' + legendName + '</i>?',
			deleteItem: _deleteLegend
		});
	};

	objHermes.clearLegends = function(apId) {

		new legendsDialog({
			apId: apId,
			message: 'All the legends will be deleted for this approval process. Are you sure you want to clear these legends?',
			buttons: function() {
				var buttons = {};
				buttons['Clear Legends']= 'clearLegends';
				buttons['Cancel']= 'cancel';
				return buttons;
			}
		});

	};


	var legendsDialog = Curriculog.WarningDialog.extend({
		clearLegends: function () {
			objHermes.deleteLegendsandTemplates(this.apId);
			this.close();
		},
		cancel: function () {
			this.close();
		}
	});

	objHermes.deleteLegendsandTemplates = function(apId) {

		return $.ajax({
			url: '/hermes/deleteLegendsandTemplates.json',
			data: {apId: apId},
			type: 'PUT',
			success: function(data){

				// reload the legends tab
				var apId = $('#approval-process-id').val();
				var editmode = (window.opener.$('#process-status').val() == 'active') ? 0 : 1;
				window.opener.hermesObject.getLegends(apId);

				// if we are Managing Legends, reload list
				if ($('#existing-hermes-legends').length > 0) {
					$('#hermes-legend-details').slideUp('slow', function() {
						$(this).removeAttr('style');
						$(this).removeClass('active');
					});
					objHermes.getScopedLegends($('#approval-process-id').val(), $('#type').val(), false, 'admin', 'getScopedLegends');
					objDom.removeMask('#hermes-legend-details');

				// if we are editing a single legend, close the dialog
				} else {
					window.close();
				}
			}
		});

	};


/****************************************************************************************************/
/*************************                                                  *************************/
/**********                                                                                **********/
/*****                                 HERMES: DATASTORE                                        *****/
/**********                                                                                **********/
/*************************                                                  *************************/
/****************************************************************************************************/


	objHermes.addSearchFilter = function(field, mode) {
		if (mode == 'remove') {
			$('#hermes-filter-' + field).remove();
			$('#and-'+field).remove();

			// enable this option in filter dropdown
			$('#new-filter option[value="' + field + '"]').attr('disabled', false);

			if ($('.filter-field:not(#new-filter-clone)').length === 0) {
				$('#hermes-search-all').show();
				$('#hermes-new-filter label').text('Or add filter');

			} else {
                if ($('.filter-field:first').attr('id') != 'new-filter-clone'){
                    $('.filter-field:first').prev('.hermes-search-or').remove();
                }
            }

		} else {

			// if this is the first filter to be added
			if ($('#hermes-search-all').length > 0) {
				$('#hermes-search-all').hide();
			}

			// build new filter
			var fieldName = $('#new-filter option[value="' + field + '"]').text();
			var filter = $('#new-filter-clone').clone().attr('id', 'hermes-filter-' + field);
			$(filter).find('label').attr('for','filter-' + field).text(fieldName + ' = ');
			$(filter).find('input').attr('name','filter-' + field).attr('id','filter-' + field);

			// if there is more than one, add OR
			if ($('.filter-field:not(#new-filter-clone)').length > 0) {
				var and = $('<div></div>').attr('id','and-' + field).attr('class', 'hermes-search-or').html('-&nbsp; and &nbsp;- ');
				$(and).insertBefore($('#hermes-new-filter'));
			}

			// insert new filter into DOM
			$(filter).insertBefore($('#hermes-new-filter'));

			// change 'or add filter' to add another filter
			$('#hermes-new-filter label').text('Add another filter');

			// disable this option from filter dropdown
			$('#new-filter option[value="' + field + '"]').attr('disabled', true);

			// reset new filter select
			$('#new-filter').val('');
		}
	};

	objHermes.searchDatastore = function(page, limit) {

		var searchParameters = {
			map_id: $('#map-id').val(),
			system_id: $('#approval-process-id').val(),
			legend_id: $('#legend-id').val(),
			include_imported: ($('#include-imported').is(':checked')) ? true : false,
			type: $('#proposal-type').val()
		};

		if ($('#child-legend-id').val() !== '0') {
			searchParameters['legend_id'] = $('#child-legend-id').val();
		}

		// gather search parameters
		var filters = [];
		$('.filter-field:not(#new-filter-clone)').each(function(index, item) {
			var filter = {};
			filter[$(this).find('label').text().match(/(.*)\s\=/)[1]] = $(item).find('input').val();
			filters.push(filter);
		});

		// If program type, are we searching programs or shared cores?
		if ( ($('#search-programs').length > 0) && ($('#search-programs').val() == 'sharedcores') ) {
			var filter = {};
			filter['shared-core'] = 1;
			filters.push(filter);
			searchParameters['type'] = 'core';
		}

		searchParameters['filter'] = filters;

		// sort
		var order = $('#titleFields').val();

		// modified date
		var startDate = objHermes.dateFormatter($('#start-date').val());
		var endDate = objHermes.dateFormatter($('#end-date').val());

		if ( (startDate !== '') && (endDate !== '') ) {

			var modifiedArray = [];
			var modified = {
				compare : '>=',
				value : startDate
			};
			modifiedArray.push(modified);

			modified = {
				compare : '<=',
				value : endDate
			};
			modifiedArray.push(modified);
			searchParameters['modified'] = modifiedArray;

		} else if(startDate !== '') {
			searchParameters['modified'] = {
				compare : '>=',
				value : startDate
			};

		} else if(endDate !== '') {

			searchParameters['modified'] = {
				compare : '<=',
				value : endDate
			};
		}

		// get paging start and end
		var start = Number(page * limit) - Number(limit);
		var end = Number(page * limit);
		if (start < 0) {
			start = 0;
		}
		searchParameters['paginate'] = {
			start: start,
			end: end
		};

		$.ajax({
			url: '/hermes/searchDatastore',
			data: {
				searchParameters: JSON.stringify(searchParameters),
				order: $('#order').val(),
				method: $('#method').val(),
				showMatch: false,
				page: page,
				limit: limit,
				display: 'searchResults'
			},
			type: 'GET',
			beforeSend: function() {
				objDom.addLoadingMask('#hermes-content');
			},
			success: function(data) {
				$('#hermes-search-results').addClass('active');
				$('#hermes-search-results').contents().remove();
				$('#hermes-search-results').html(data);
				objDom.removeMask('#hermes-content');

				objHermes.disableCartItems();

				$('#page').val(page);

			}
		});

	};

	objHermes.addToCart = function(itemId, action) {

		if (!$('#hermes-course-cart').hasClass('active')) {
			$('#hermes-course-cart').addClass('active');
		}

		var cart = [];
		try {
			cart = JSON.parse($('#course-cart').val());
		} catch(e) {
			// empty!
		}

		if (action == 'remove') {

			// remove from cart object
			var indexToRemove = 0;
			$.each(cart, function(index, courseItem) {
				if  (courseItem.id == itemId) {
					indexToRemove = index;
				}
			});
			cart.splice(indexToRemove, 1);
			$('#course-cart').val(JSON.stringify(cart));

			// remove from cart dom
			$('#course-' + itemId).remove();

			// make course available in search results
			$('#item-' + itemId).removeClass('in-cart');

			// if cart is empty, hide it.
			if(cart.length === 0) {
				$('#hermes-course-cart').removeClass('active');
			}

		} else {

			item = {
				id: itemId,
				name: $('#item-' + itemId).find('h4').text()
			};

			// place item in json cart
			cart.push(item);
			$('#course-cart').val(JSON.stringify(cart));

			// place item in dom
			var item = $('#item-' + itemId).clone().attr('id','course-' + itemId);
			$(item).append('<div class="actions"><a href="#" class="hermes-widget delete-item tip" title="Remove course from cart"><span>delete</span></a></div>');
			$('#hermes-course-cart-content').append(item);

			// disable course in search results
			$('#item-' + itemId).addClass('in-cart');

		}

	};


	objHermes.disableCartItems = function() {
		var cart = [];
		try {
			cart = JSON.parse($('#course-cart').val());
		} catch(e) {
			// empty!
		}

		$.each(cart, function(index, item) {
			$('#item-' + item.id).addClass('in-cart');
		});

	};


/****************************************************************************************************/
/*************************                                                  *************************/
/**********                                                                                **********/
/*****                                HERMES: IMPACT REPORT                                     *****/
/**********                                                                                **********/
/*************************                                                  *************************/
/****************************************************************************************************/

	objHermes.runImpactReport = function(postData) {

		if (!postData){
			postData = objHermes.getImpactReportParameters();
		}

		$.ajax({
			url: '/hermes/runImpactReport.json',
			data: {filters: postData},
			type: 'GET',
			beforeSend: function() {
				$('#hermes-systems-list').hide();
				$('.report-content').addClass('loading');
				objDom.addLoadingMask('.report-content');
			},
			success: function(data) {
				if (postData.filters.report_type === 'proposal'){
					objHermes.showImpactReport(data.reportId);
				}

			}
		});

	};

	objHermes.getImpactReportParameters = function () {

		// catalog names (for display)
		var resourceNames = [];
		var resourcesList = [];
		$('#existing-hermes-maps .item.in-cart').each(function(index, item) {
			var text = $(item).text();
			resourceNames.push($(item).text().trim());
			var item_dict = {};
			var itemDetails = $(item).find('input');
			var item_id = $(item).attr('id');
			item_dict['id'] = item_id.replace('item-', '');
			itemDetails.each(function() {
				var name = this.name.replace(item_id + '-', '');
				item_dict[name] = this.value;
			});
			resourcesList.push(item_dict);

		});

		resourceNames = encodeURIComponent(resourceNames.join(', '));

		var postData = {
				filters: {
					prefix: encodeURIComponent($('#prefix').val()),
					code: encodeURIComponent($('#code').val()),
					resources: resourcesList,
					resourceNames: resourceNames,
					report_type: 'proposal'
				}
			};

		return postData;
	};

	objHermes.showImpactReport = function(reportId) {

		var interval = setInterval(function() {
		$.ajax({
			type: 'GET',
			url: '/rpc/ImpactReportProposal/check_results.json',
			data: {reportId: reportId},
			success: function(data){
				if (data.state == 'SUCCESS'){
					$('.report-content').replaceWith(data.view);
					clearInterval(interval);
				}
				if (data.state == 'FAILED'){
					growlError('Error', 'An Error occurred while creating your Impact Report');
					objDom.removeMask('.report-content');
					clearInterval(interval);
				}
			}
			});}, 3000);

	};

	objHermes.loadSelectedSystems = function() {

		// if items are already selected, reload them
		if ($('#course-cart').val().length > 0) {

			var cart = JSON.parse($('#course-cart').val());

			$.each(cart, function(system, maps) {
				$.each(maps, function(index, mapId) {
					// Add to Sources Cart
					objHermes.manageSystemCart(mapId, 'add');

				});
			});

		}

		objDom.removeMask('#existing-hermes-maps-list');

	};


	/*
		Structure of cart:
			{"system_short": [mapId, mapId]}
	*/

	objHermes.manageSystemCart = function(mapId, action) {

		var hermesSystem = $('#item-' + mapId).find('input[name="item-'+ mapId +'-system-short"]').val();

		// cart
		var cart = {};
		try {
			cart = JSON.parse($('#course-cart').val());
		} catch(e) {
			// empty!
		}

		if (action == 'remove') {

			// remove from cart object
			var indexToRemove = 0;
			$.each(cart, function(system, maps) {
				$.each(maps, function(index, item) {
					if  (String(mapId) == String(item)) {
						indexToRemove = index;
					}
				});

			});

			cart[hermesSystem].splice(indexToRemove, 1);
			if (cart[hermesSystem].length === 0) {
				delete cart[hermesSystem];
			}

			$('#course-cart').val(JSON.stringify(cart));

			// make course available in search results
			$('#item-' + mapId).removeClass('in-cart');


		} else {

			// check if the item is already in the cart
			if (hermesSystem in cart) {
				if ($.inArray(mapId, cart[hermesSystem]) != -1) {

					// remove it and make it again
					objHermes.manageSystemCart(mapId, 'remove', []);

					// reset cart now from the updated field
					cart = JSON.parse($('#course-cart').val());
				}
			}

			// place item in json cart
			if (hermesSystem in cart) {
				cart[hermesSystem].push(mapId);

			} else {
				var catalogs = [];
				catalogs.push(mapId);
				cart[hermesSystem] = catalogs;
			}

			$('#course-cart').val(JSON.stringify(cart));

			// place item in dom
				var item = $('#item-' + mapId).clone().attr('id','course-' + mapId);

				// add delete button
				$(item).append('<div class="actions"><a href="#" class="hermes-widget delete-item tip" title="Remove source from cart"><span>delete</span></a></div>');
				$('#hermes-course-cart-content').append(item);

			// disable course in search results
			$('#item-' + mapId).addClass('in-cart');

		}


	};

	objHermes.finalizeSystemsCart = function() {

		// build list that will display on the reports page
		var list = $('<ul></ul>');
		$('#existing-hermes-maps li.in-cart').each(function(index, item) {
			$(item).clone().appendTo(list);
		});

		// display list on report
		window.opener.$('#catalogs').val($('#course-cart').val());
		window.opener.$('#report-7-resource ul.selected-external-systems').html($(list).html());

		// change impact report (parent screen) to reflect systems selected
		if ($('#existing-hermes-maps li.in-cart').length > 0) {
			window.opener.$('#report-7-resource .add-widget strong').text('Modify External Systems');
			window.opener.$('button.report-7').attr('disabled', false);

		} else {
			window.opener.$('#report-7-resource .add-widget strong').text('Add External System');
			window.opener.$('button.report-7').attr('disabled', true);

		}

		window.close();
	};

/****************************************************************************************************/
/*************************                                                  *************************/
/**********                                                                                **********/
/*****                                    HERMES: TASKS                                         *****/
/**********                                                                                **********/
/*************************                                                  *************************/
/****************************************************************************************************/

	/*
	 * getScopedMaps: retrieves all maps for all systems, regardless of system status
	 * used by procedures file on page load of hermesMap (integration settings -> Map External Systems)
           and hermesTask (integration settings -> Sync External Systems) for the map select
	 * takes: display
	 * returns: nothing
	 */
	objHermes.getTasks = function(callback) {
		$.ajax({
			url: '/hermes/getTaskElements',
			data: {
				display: 'getTasks'
			},
			type: 'GET',
			beforeSend: function() {
				objDom.addLoadingMask('#existing-hermes-tasks');
			},
			success: function(data) {
				$('#existing-hermes-tasks').contents().remove();
				$('#existing-hermes-tasks').html(data);
				objDom.removeMask('#existing-hermes-tasks');
				$('#create-hermes-task').removeClass('active');

				// Check the status of the tasks
				$('#existing-hermes-tasks .item.running').each(function(index, item) {
					var taskId = $(this).attr('id').replace('item-','');
					var processId = $('#item-' + taskId + '-process-id').val();
					objHermes.checkCron(taskId, processId, 'Tasks', $(this).attr('id'));
				});

				callback && callback();
			}
		});
	};



	/*
	 * getTasks: retrieves tasks as html list that allows editing of items
	 * used by procedures file on page load of hermesTask popup
	 * takes: nothing
	 * returns: html code for hermesTask popup current tasks list
	 */

	// objHermes.getTasks = function(status, meta, callback) {
	// 	$.ajax({
	// 		url: '/hermes/getTasks',
	// 		data: {display: 'getTasks'},
	// 		type: 'GET',
	// 		beforeSend: function() {
	// 			objDom.addLoadingMask('#existing-hermes-tasks');
	// 		},
	// 		success: function(data) {
	// 			$('#existing-hermes-tasks').contents().remove();
	// 			$('#existing-hermes-tasks').html(data);

	// 			// Check the status of the tasks
	// 			$('#existing-hermes-tasks .item.running').each(function(index, item) {
	// 				var taskId = $(this).attr('id').replace('item-','');
	// 				var processId = $('#item-' + taskId + '-process-id').val();
	// 				objHermes.checkCron(taskId, processId, 'Tasks', $(this).attr('id'));
	// 			});

	// 			callback && callback();

	// 		}
	// 	});
	// };


	/*
	 * saveTask: saves task
	 * used by "save task" button click event on hermesTask
	 * takes: nothing
	 * returns: nothing
	 */

	objHermes.saveTask = function() {

		var params = ($('#hermes-task-params').val() !== '') ? JSON.parse($('#hermes-task-params').val()) : {};

		if ($('#hermes-task-modified-days').val() !== '') {
			params.daysModified = $('#hermes-task-modified-days').val();
		} else {
			delete params['daysModified'];
		}

		//params.catalog = $('#hermes-task-map').val();
		delete params['catalog'];

		var task = {
			id : $('#hermes-task-id').val(),
			map : $('#hermes-task-map').val(),
			legend: $('#hermes-task-legend').val(),
			label : $('#hermes-task-map option:selected').text().replace(/\t\n/g, ''),
			mins : $('#hermes-task-mins').val(),
			hours : (($('#hermes-task-hours').val() === 'every')) ? '*' : $('#hermes-task-hours').val(),
			days : (($('#hermes-task-days').val() === 'every')) ? '*' : $('#hermes-task-days').val(),
			months : (($('#hermes-task-months').val() === 'every')) ? '*' : $('#hermes-task-months').val(),
			params : JSON.stringify(params)
		};

		$.validity.start();
		$('#hermes-task-map').require();
		$('#hermes-task-mins').assert(function(){return $('#hermes-task-mins').chosen().val();}, 'This field is required.');
		$('#hermes-task-hours').assert(function(){return $('#hermes-task-hours').chosen().val();}, 'This field is required.');
		$('#hermes-task-days').assert(function(){return $('#hermes-task-days').chosen().val();}, 'This field is required.');
		$('#hermes-task-months').assert(function(){return $('#hermes-task-months').chosen().val();}, 'This field is required.');
		var result = $.validity.end();

		if (result.valid) {
			$.ajax({
				url: '/hermes/saveTask.json',
				data: task,
				type: 'POST',
				beforeSend: function() {
					objDom.addLoadingMask('#hermes-task-details-content');
				},
				success: function(data) {
					window.location = '/hermes?display=hermesTask';
					objDom.removeMask('#hermes-task-details-content');
				}
			});
		}

	};

	/*
	 * editTask: creates the chosen select dropdowns for creating a task
	 * used by create-new-task link from procedure for hermesTask popup
	 * takes: taskId (or undefined if new task)
	 * returns: nothing
	 */

	objHermes.editTask = function(taskId, callback) {
		$('#hermes-task-details').addClass('active');
		$('#hermes-task-id').val(taskId);

		if (! taskId) {
			// create dropdowns and lock them
			objHermes.getScopedMapsBySystemSelect();

			if(! $('#create-hermes-task').hasClass('active'))
				$('#create-hermes-task').addClass('active');

			$('#hermes-task-system').val('');
			$('#hermes-task-map').val('');
			$('#hermes-task-params').val('');
			$('#hermes-task-modified-days').val('');
			$('#hermes-task-details h2').text('New Task Details');

			// mins
			$('#hermes-task-mins').chosen().change(function() {
				objHermes.changeScheduleDropdown('hermes-task-mins');
			}).val(function() {
				return objHermes.loadScheduleValue('hermes-task-mins', '');
			}).trigger("liszt:updated");

			// hours
			$('#hermes-task-hours').chosen().change(function() {
				objHermes.changeScheduleDropdown('hermes-task-hours');
			}).val(function() {
				return objHermes.loadScheduleValue('hermes-task-hours', '');
			}).trigger("liszt:updated");

			// days
			$('#hermes-task-days').chosen().change(function() {
				objHermes.changeScheduleDropdown('hermes-task-days');
			}).val(function() {
				return objHermes.loadScheduleValue('hermes-task-days', '');
			}).trigger("liszt:updated");

			// months
			$('#hermes-task-months').chosen().change(function() {
				objHermes.changeScheduleDropdown('hermes-task-months');
			}).val(function() {
				return objHermes.loadScheduleValue('hermes-task-months', '');
			}).trigger("liszt:updated");

			// scroll to map
			// $('body').scrollTo($('#hermes-task-details'),{duration:400});

			var target = $('#hermes-task-details');
			if( target.length ) {
				$('html, body').animate({
					scrollTop: target.offset().top
				}, 400);
			}

		} else {

			// get task schedule values
			$.ajax({
				url: '/hermes/getTask.json',
				data: {id: taskId},
				type: 'GET',
				beforeSend: function() {
					objDom.addLoadingMask('#hermes-task-details-content');
				},
				success: function(data) {
					var params = JSON.stringify(data.task.params);
					$('#create-hermes-task').removeClass('active');

					// create dropdowns and lock them
					objHermes.getScopedMapsBySystemSelect(undefined, data.task.map, data.task.legend, data.task.id);

					$('#hermes-task-details h2').text('Edit Task Details');
					$('#hermes-task-id').val(data.task.id);

					$('#hermes-task-params').val(params);

					if ((params !== null) && (params !== '')) {
						try {
							$('#hermes-task-modified-days').val((params.daysModified !== null) ? params.daysModified : '');
						} catch (e) {
							('bad json or a list'); // wtf is this?
							params = {};
							$('#hermes-task-modified-days').val('');
						}
					}

					// mins
					$('#hermes-task-mins').chosen().change(function() {
						objHermes.changeScheduleDropdown('hermes-task-mins');
					}).val(function() {
						return objHermes.loadScheduleValue('hermes-task-mins', data.task.mins);
					}).trigger("liszt:updated");

					// hours
					$('#hermes-task-hours').chosen().change(function() {
						objHermes.changeScheduleDropdown('hermes-task-hours');
					}).val(function() {
						return objHermes.loadScheduleValue('hermes-task-hours', data.task.hours);
					}).trigger("liszt:updated");

					// days
					$('#hermes-task-days').chosen().change(function() {
						objHermes.changeScheduleDropdown('hermes-task-days');
					}).val(function() {
						return objHermes.loadScheduleValue('hermes-task-days', data.task.days);
					}).trigger("liszt:updated");

					// months
					$('#hermes-task-months').chosen().change(function() {
						objHermes.changeScheduleDropdown('hermes-task-months');
					}).val(function() {
						return objHermes.loadScheduleValue('hermes-task-months', data.task.months);
					}).trigger("liszt:updated");

					// scroll to map
					// $('body').scrollTo($('#hermes-task-details'),{duration:400});

					var target = $('#hermes-task-details');
					if( target.length ) {
						$('html, body').animate({
							scrollTop: target.offset().top
						}, 400);
					}

					objDom.removeMask('#hermes-task-details-content');

				}
			});
		}

	};


	objHermes.runTask = function(taskId) {
		$.ajax({
			url: '/hermes/runTask.json',
			data: {id: taskId},
			type: 'PUT',
			beforeSend: function() {
				objDom.addLoadingMask('#item-'+taskId);
			},
			success: function(data) {
				objHermes.getTasks();
				objDom.removeMask('#item-'+taskId);

			}
		});
	};

	objHermes.checkCron = function(taskId, processId, type, progressBarId, maskLayer) {
		var updateMessage = function(dom, message, speed){
			if ( message != dom.html() ){
				dom.fadeOut(speed, function(){
					jQuery(this).html(message);
					jQuery(this).fadeIn(speed);
				});
			}
		};

		var clearMessage = function(dom, speed){
			dom.fadeOut(speed, function(){
				jQuery(this).html("");
			});
		};

		$.ajax({
			url: '/hermes/checkTask.json',
			data: {
				id: taskId,
				processId: processId,
				selfDestruct: (type == 'ImpactReport') ? 1 : 0
			},
			type: 'GET',
			beforeSend: function() {},
			success: function(data) {

				var message = data.result.status;

				var bar = $('#' + progressBarId);
				var progressBar = $('#' + progressBarId).children('.progress_wrapper');
				var messageBanner = $('#percent-' + progressBarId);

				if ( data.result && data.result.status != "FAILURE") {

					message = message.replace(/_/g," ");
					message = message.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});

					// if in progress
					if ((data.result.status == "PROGRESS") || (data.result.status == "PULLING_RESULTS")) {
						var percent = -1, progress = data.result.meta;

						if (progress.hasOwnProperty('total') && progress.hasOwnProperty('current')){
							percent = Math.round(100*(progress.current/progress.total));
							barWidth = Math.round((percent*bar.width())/100);
						}

						if (percent >= 0){
							progressBar.removeClass('inderminate');
							progressBar.animate({'width': barWidth}, "slow");

							if (data.result.status == "PULLING_RESULTS"){
								msg = message;
							} else {
								msg = percent + '%';
							}
							updateMessage(messageBanner, msg, 400);

						} else {
							progressBar.addClass('inderminate');
							updateMessage(messageBanner, "Processing", 400);

						}

						setTimeout( function () { objHermes.checkCron(taskId, processId, type, progressBarId);}, 5000 );

					} else if(data.result.status == "SUCCESS") {
						updateMessage(messageBanner, message, "slow");

						progressBar.animate({'width': bar.width()}, { duration : "slow", complete : function(){
							setTimeout( function () {
								clearMessage(messageBanner, "slow");
								progressBar.fadeOut('slow', function() {
									$('#' + progressBarId).removeClass('running');
								}); }, 2000 );
								objHermes['get' + type](data.result.status, data.result.meta);
						}});

					} else if(data.result.status == "PENDING") {
						updateMessage(messageBanner, message, "fast");
						setTimeout( function () { objHermes.checkCron(taskId, processId, type, progressBarId);}, 5000 );

					} else {
						clearMessage(messageBanner, "fast");

					}
					$('#existing-hermes-tasks #item-' + taskId + ' .more-info .status-value').text(message);

                    $('#existing-hermes-tasks #item-' + taskId + ' .more-info').slideDown(600, function(){
                        $(this).addClass('active');
                    });

				} else {
					$('#existing-hermes-tasks').addClass('list-scroll');
					objDom.removeMask('#existing-hermes-tasks');
					$('#' + progressBarId).addClass('error').removeClass('running');
					progressBar.animate({'width': '100%'}, "slow");
					$('#' + progressBarId + ' .more-info .item-sublist').html('');

					if (data.result.hasOwnProperty('meta')) {
						var meta = data.result.meta;
						var moreInfo = '';

						if (meta.hasOwnProperty('reason') && meta.hasOwnProperty('items') && meta.hasOwnProperty('type')){

							moreInfo = 'An error has occurred while communicating with the reference system to retrieve the following ' + meta.type + ':</span></p>';
							errorItems = '';
							var items = meta.items;
							for (var key in items) {
								if (items.hasOwnProperty(key)) {
									var item = items[key];
									errorItems += '<li>' + item.title + '</li>';
								}
							}
						}
						$('#' + progressBarId + ' .more-info .status-value').addClass('error').html(moreInfo);
						$('#' + progressBarId + ' .more-info .item-sublist').html(errorItems);

					} else {
						message = "An error occurred.";
						$('#' + progressBarId + ' .more-info .status-value').addClass('error').html(message);

					}

					$('#' + progressBarId + ' .more-info').slideDown(600, function(){
						$(this).addClass('active');
					});
					clearMessage(messageBanner, "fast");

				}

			}
		});
	};

	objHermes.deleteTask = function(taskId) {

		function _deleteTask() {
			return $.ajax({
				url: '/hermes/deleteTask.json',
				data: {id: taskId},
				type: 'PUT',
				beforeSend: function() {
					objDom.addLoadingMask('#item-'+taskId);
				},
				success: function() {
					objDom.removeMask('#item-'+taskId);
					$('#item-' + taskId).remove();

					if ($('#existing-hermes-tasks li').length === 0) {
						$('#existing-hermes-tasks').append(
							'<li class="no-items">You have no tasks established</li>'
						);
					}
				}
			});
		}

		var taskName = $('#item-' + taskId + ' .task-name').text().trim();
		new DeleteWarning({
			message: 'Are you sure you want to delete the task <i>' + taskName + '</i>?',
			deleteItem: _deleteTask
		});
	};

/****************************************************************************************************/
/*************************                                                  *************************/
/**********                                                                                **********/
/*****                                   Clear All IM Data                                      *****/
/**********                                                                                **********/
/*************************                                                  *************************/
/****************************************************************************************************/


	objHermes.resetIM = function() {
		var dialog = objDialog.createBasicDialog('clear-legends', 'Reset Integration Manager Data', function(dialog, defaults) {
			// Message
			$(dialog).append('<p>Clear all Integration Manager Data?</p>');
			$(dialog).append('<p></br>NOTE: This operation will destroy all legends, system templates, </br>and maps associated with Curriculog.</p>');

			// Actions
			defaults.buttons = {
				'Ok': function() {
					$.ajax({
						beforeSend: function() {
							objDom.addCustomMask('#savepoints-column', 'Resetting Savepoint');
						},
						url: '/hermes/clearLegendsAndTemplates.json',
						type: 'PUT',
						success: function(data) {
							objDom.removeMask('#savepoints-column');
							$('#growls').notify('create', 'saved-template', {
								title: 'Integration Manager Data Reset',
								text: 'Your Integration Manager data has been successfully reset.'
							});
						}
					});
					$(this).dialog('close');
				},
				'Cancel': function() {
					$(this).dialog('close');
				}
			};
			defaults.close = function(event, ui) {
				$(this).remove();
			};
			$(dialog).dialog(defaults);
		});

	};



/****************************************************************************************************/
/*************************                                                  *************************/
/**********                                                                                **********/
/*****                                        Utilities                                         *****/
/**********                                                                                **********/
/*************************                                                  *************************/
/****************************************************************************************************/


	/*
	 * changeScheduleDropdown: loads the chosen jquery plugin on the tasks page for building schedules
	 * used by editTask
	 * takes: selectId
	 * returns: nothing
	 */

	objHermes.changeScheduleDropdown = function(selectId) {
		$('#' + selectId + ' option').removeAttr('disabled');
		$('#' + selectId + '-optgroup').attr('label','or...');
		$('#' + selectId).trigger("liszt:updated");

		if ( ($('#' + selectId).val() !== null) && ($('#' + selectId).val().length > 0) && ($.inArray('every', $('#' + selectId).val()) != -1 ) ) {
			$('#' + selectId + ' option[value!="every"]').attr('disabled', true);
			$('#' + selectId).trigger("liszt:updated");

		} else if ( ($('#' + selectId).val() !== null) && ($('#' + selectId).val().length > 0) && ($.inArray('every', $('#' + selectId).val()) == -1 ) ) {
			$('#' + selectId + ' option[value="every"]').attr('disabled', true);
			$('#' + selectId + '-optgroup').attr('label','and...');
			$('#' + selectId).trigger("liszt:updated");
		}
	};

	/*
	 * loadScheduleValue: loads the current value into chosen jquery plugin and adjusts the and/or behavior
	 * used by editTask
	 * takes: selectId, selectedValue
	 * returns: selectedValue
	 */

	objHermes.loadScheduleValue = function(selectId, selectedValue) {
		// Every minute was removed as an option for hermes-task-mins so we must
		// ensure that we don't try to select it
		if ( selectId === 'hermes-task-mins' && selectedValue === '*') {
			selectedValue = '';
		}
		if (selectedValue === '') {
			selectedValue = '';
			$('#' + selectId + ' option').removeAttr('disabled');
			$('#' + selectId + '-optgroup').attr('label','or...');

		}
		else if (selectedValue === '*') {
			$('#' + selectId + ' option[value!="every"]').attr('disabled', true);
			selectedValue = 'every';
		}
		else if (selectedValue === 'every') {
			$('#' + selectId + ' option[value!="every"]').attr('disabled', true);
			$('#' + selectId + '-optgroup').attr('label','and...');
		}
		else {
			$('#' + selectId + ' option[value="every"]').attr('disabled', true);
			$('#' + selectId + '-optgroup').attr('label','and...');
		}

		return selectedValue;
	};

	/*
	 * addFileColumn: adds a new column to the map
	 * used by onClick event for "add field column" link
	 * takes: nothing
	 * returns: nothing
	 */

	objHermes.addFileColumn = function() {
		var rowClone = $('#hermes-map-columns tbody tr:first').clone();

		// apply odd class, if applicable
		var count = $('#hermes-map-columns tbody tr').length;
		if (count % 2 !== 0) {
			$(rowClone).addClass('odd');
		}

		// change column name
		$(rowClone).find('.column-name').text('Column ' + Number(count + 1));

		// remove selected field name
		var select = $(rowClone).find('select');
		$(select).find('option:selected').removeAttr('selected');

		$('#hermes-map-columns tbody').append(rowClone);
	};

	/*
	 * deleteFileColumn: deletes a column from the map
	 * used by onClick event for the individual row's delete icon
	 * takes: deleteItem object
	 * returns: nothing
	 */

	objHermes.deleteFileColumn = function(deleteItem) {

		if ($('#hermes-map-columns tbody tr').length > 1) {
			$(deleteItem).closest('tr').remove();
			objHermes.updateMapDisplay();

		} else {
			var warning = jQuery('<div></div>').attr('id','delete-last-column').text('You must have at least one column for this map. This column will not be deleted.');
			$('#hermes-content').append(warning);
			$( "#delete-last-column" ).dialog({
				resizable: false,
				width:500,
				height:150,
				modal: true,
				buttons: {
					"Ok": function() {
						$( this ).dialog( "close" );
					}
				}
			});
		}
	};

	/*
	 * updateMapDisplay: after actions are taken on the map, do the following:
			- renumber the column name
			- apply odd class
			- change the name of the select
	 * used by deleteFileColumn and getScopedMap
	 * takes: nothing
	 * returns: nothing
	 */

	objHermes.updateMapDisplay = function() {
		$('#hermes-map-columns tbody tr').each(function(index, item) {
			// apply odd class
			if (index % 2 !== 0) {
				$(item).addClass('odd');
			} else {
				$(item).removeClass('odd');
			}

			// renumber the column name
			$(item).find('.column-name').text('Column ' + Number(index + 1));

		});
	};

	/*
	 * addFieldName: when user types a new field name into the "Add Field" input
			- Adds name to hidden JSON system fields
			- Adds name to each column's select
			- Adds name to Remove Field select
	 * used by procedures file for "Create Field" button
	 * takes: nothing
	 * returns: nothing
	 */

	objHermes.addFieldName = function(name) {

		// update hidden field
		var sourceFieldNames = JSON.parse($('#sourceFieldNames').val());
		var newKey = 1;
		var keys = [];
		var newValue = name;
		var exists = false;
		for (var key in sourceFieldNames) {
			if (sourceFieldNames.hasOwnProperty(key)) {
				keys.push(Number(key));
				if (sourceFieldNames[key].toLowerCase() == name.toLowerCase()){
					exists = true;
				}
			}
		}

		if ( !exists && newValue.length > 0){
			//keys.sort();
			if (keys.length > 0){
				highestKey = Math.max.apply(null, keys);
				newKey = Number(highestKey + 1);
			}
			sourceFieldNames[newKey] = newValue;

			// update dropdowns
			$('select[name="source-definition[]"]').append('<option value="'+ newKey +'">' + newValue + '</option>');
			$('#remove-source-definition').append('<option value="'+ newKey +'">' + newValue + '</option>');
			$('#unique-item-identifier').append('<option value="'+ newKey +'">' + newValue + '</option>').trigger("liszt:updated");
		}

		$('#field-name').val('');
		$('#sourceFieldNames').val(JSON.stringify(sourceFieldNames));

	};

	/*
	 * deleteFieldName: when user removes a previously entered field name into the map columns
			- Removes name from hidden JSON system fields
			- Removes name from each column's select
			- Removes name from Remove Field select
	 * used by procedures file for "Remove Field" button
	 * takes: nothing
	 * returns: nothing
	 */

	objHermes.deleteFieldName = function(id) {
		// update dropdowns
		$('select[name="source-definition[]"] option[value="'+id+'"]').remove();
		$('#remove-source-definition option[value="'+id+'"]').remove();
		$('#remove-source-definition').val($("#remove-source-definition option:first").val());

		// update the unique field ids
		$('#unique-item-identifier option[value="'+id+'"]').remove();
		$('#unique-item-identifier').trigger("liszt:updated");

		// update hidden field
		var sourceFieldNames = JSON.parse($('#sourceFieldNames').val());
		delete sourceFieldNames[id];
		$('#sourceFieldNames').val(JSON.stringify(sourceFieldNames));
	};


	objHermes.dateFormatter = function(dateString) {
		if (dateString !== '') {
			var dateArray = dateString.split('/');
			var date = dateArray[2] + '/' + dateArray[0] + '/' + dateArray[1];
			return date;

		} else {
			return '';
		}
	};

	return objHermes;

};






